import React from 'react';
import { useTranslation } from 'react-i18next';
import loader from '../../images/overlay_loader.gif';
import './OverlayLoader.scss';

const OverlayLoader = () => {
  const { t } = useTranslation();

  return (
    <div className="overlay-loader bg-secondary fixed-top w-100 h-100 text-white d-flex flex-column justify-content-center align-items-center font-weight-bold">
      <div className="mb-4">
        <img src={loader} width="80" alt="" />
      </div>
      <div>{t('app:loadingEntryMessage')}</div>
    </div>
  );
};

export default OverlayLoader;
